import React, { useState } from 'react';
import { Card, CardContent } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import SafeIcon from '../../common/SafeIcon';
import { courseLibrary } from '../../data/courseLibrary';
import { motion, AnimatePresence } from 'framer-motion';

export const PublicCourses = () => {
  const [selectedCategory, setSelectedCategory] = useState("Alle");
  const categories = ["Alle", ...new Set(courseLibrary.map(c => c.category))];

  const filteredCourses = courseLibrary.filter(c => 
    selectedCategory === "Alle" || c.category === selectedCategory
  );

  return (
    <div className="py-20 bg-slate-50 min-h-screen">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h1 className="text-4xl md:text-5xl font-extrabold text-slate-900 mb-4">Kurs & Kompetanse</h1>
          <p className="text-slate-500 text-lg max-w-2xl mx-auto">
            Hev kompetansen i din virksomhet med våre spesialiserte kurs utviklet av organisasjonspsykologer.
          </p>
        </div>

        {/* Filter Bar */}
        <div className="flex flex-wrap justify-center gap-2 mb-12">
          {categories.map(cat => (
            <button
              key={cat}
              onClick={() => setSelectedCategory(cat)}
              className={`px-5 py-2.5 rounded-full text-sm font-bold transition-all ${
                selectedCategory === cat 
                ? 'bg-indigo-600 text-white shadow-lg shadow-indigo-200' 
                : 'bg-white text-slate-600 hover:bg-slate-100'
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <AnimatePresence mode="popLayout">
            {filteredCourses.map((course) => (
              <motion.div
                key={course.id}
                layout
                initial={{ opacity: 0, scale: 0.9 }}
                animate={{ opacity: 1, scale: 1 }}
                exit={{ opacity: 0, scale: 0.9 }}
                transition={{ duration: 0.2 }}
              >
                <Card hover={true} className="flex flex-col h-full bg-white border-none shadow-sm">
                  <div className="relative">
                    <img src={course.img} alt={course.title} className="h-48 w-full object-cover rounded-t-2xl" />
                    <div className="absolute top-4 left-4">
                      <span className="text-[10px] font-bold text-white bg-indigo-600/90 backdrop-blur-sm px-3 py-1.5 rounded-full uppercase tracking-widest shadow-lg">
                        {course.category}
                      </span>
                    </div>
                  </div>
                  <CardContent className="flex-1 p-6 space-y-4">
                    <div className="flex justify-between items-start">
                      <span className="text-[10px] font-bold text-slate-400 uppercase tracking-widest">{course.level}</span>
                      <span className="text-sm font-black text-indigo-600">{course.price}</span>
                    </div>
                    <h3 className="text-xl font-bold text-slate-900 leading-tight">{course.title}</h3>
                    <p className="text-sm text-slate-500 leading-relaxed line-clamp-2">
                      {course.description}
                    </p>
                    <div className="flex items-center gap-4 text-[11px] font-bold text-slate-400 pt-2 border-t border-slate-50">
                      <div className="flex items-center gap-1.5">
                        <SafeIcon name="Clock" className="text-indigo-400" /> {course.duration}
                      </div>
                      <div className="flex items-center gap-1.5">
                        <SafeIcon name="Video" className="text-indigo-400" /> Digitalt / Hybrid
                      </div>
                    </div>
                  </CardContent>
                  <div className="p-6 pt-0">
                    <Button variant="secondary" className="w-full font-bold">Les mer & påmelding</Button>
                  </div>
                </Card>
              </motion.div>
            ))}
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};